// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { RiskRangeApi } from '../types/risk-range.types';
import { riskRangeHttpApi } from './risk-range.api';
import { riskRangeMockApi } from './risk-range.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const riskRangeApi: RiskRangeApi = useMock
  ? riskRangeMockApi
  : riskRangeHttpApi;
